// @ts-nocheck
/**
 * @description Idempotent function. Runs snapchat pixel code. See snapchat ads dashboard for more info. Contact marketing to get access.
 */
export function snapchatPixel(pixelId) {
  /* eslint-disable */
  ;
  (function (e, t, n) {
    if (e.snaptr) return;
    var a = e.snaptr = function () {
      a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments);
    };
    a.queue = [];
    var s = 'script';
    var r = t.createElement(s);
    r.async = !0;
    r.src = n;
    var u = t.getElementsByTagName(s)[0];
    u.parentNode.insertBefore(r, u);
  })(window, document, 'https://sc-static.net/scevent.min.js');
  /* eslint-enable */
  snaptr('init', pixelId);
}